import { Navigate } from 'react-router-dom';
import { useSelector } from '../redux/store';

export default function InsuranceGuard({ children }) {
  const { insurance } = useSelector((state) => state.insurance);

  if (!insurance) {
    return <Navigate to='/' />;
  }

  return <>{children}</>;
}
